export interface LoginResponse {
  message: string;
  encryptedMsisdn: string;
  sessionId: string;
  rememberMeToken: string;
  maskedMsisdn: string;
  authToken: string;
  code: string;
  showCaptcha: boolean;
  clientSecret: string;
}

export class LoginError {
  constructor(public code: string, public message: string) {}
}

export class LoginAttemptRejection {
  constructor(
    public reason: LoginError | any,
    public captchaRequired: boolean = false
  ) {}
}



// WEBPACK FOOTER //
// src/app/common/services/auth/auth.model.ts